import React, { useEffect, useState } from "react";
import { apiUrl } from "../../../environment/environment";
import { formatDateString } from "./../../../shared/services/helper";
import _axiosInstance from "../../../shared/services/axios.instance";
const AdminUsers = () => {
  const [usersList, setUserList] = useState([]);

  const getUsers = async () => {
    if (!sessionStorage.getItem("token")) {
      return;
    }
    await _axiosInstance
      .get(`${apiUrl}auth/user`, {
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log("RES", res.data);
        if (res.data.status === "ok") {
          console.log("SETTING UP", res.data.data);
          setUserList(res.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  useEffect(() => {
    getUsers();
  }, []);
  return (
    <React.Fragment>
      <div className="container">
        <div className="title">
          <h2>Users</h2>
        </div>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Username</th>
                <th scope="col">Email</th>
                <th scope="col">Created At</th>
              </tr>
            </thead>
            <tbody>
              {usersList.map((x) => {
                return (
                  <tr key={x.id}>
                    <td>{x.username}</td>
                    <td>{x.email}</td>
                    <td>{formatDateString(x.createdAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
};
export { AdminUsers };
